import RaceFilterComparator from './RaceFilterComparator';
export const racesFilterConfig = [
    {
        label: 'name',
        stateKey: 'name',
        filterKeys: ['name'],
        hidden: true,
        comparator: RaceFilterComparator.name
    },
    {
        label: 'Entry fee',
        stateKey: 'entryFee',
        filterKeys: ['entryFeeMin', 'entryFeeMax'],
        comparator: RaceFilterComparator.entryFee,
        range: { min: 0, max: 5000 }
    },
    {
        label: 'Prize pool',
        stateKey: 'prizePool',
        filterKeys: ['prizePoolMin', 'prizePoolMax'],
        comparator: RaceFilterComparator.prizePool,
        range: { min: 0, max: 5000 }
    },
    {
        label: 'Race date',
        stateKey: 'raceDate',
        filterKeys: ['raceDate'],
        comparator: RaceFilterComparator.raceDate,
        date: true
    },
    {
        label: 'Location',
        stateKey: 'location',
        filterKeys: ['location'],
        comparator: RaceFilterComparator.location,
        location: true
    },
    {
        label: 'Class',
        stateKey: 'class',
        filterKeys: ['class'],
        comparator: RaceFilterComparator.class,
        textFilterOptions: [
            { name: 'All', value: 'All' },
            { name: 'Class 1', value: '1' },
            { name: 'Class 2', value: '2' },
            { name: 'Class 3', value: '3' },
            { name: 'Class 4', value: '4' },
            { name: 'Class 5', value: '4' }
        ]
    },
    {
        label: 'Distance (m)',
        stateKey: 'distance',
        filterKeys: ['distanceMin', 'distanceMax'],
        comparator: RaceFilterComparator.distance,
        range: { min: 0, max: 4000 }
    },
    {
        label: 'Surface',
        stateKey: 'surface',
        filterKeys: ['surface'],
        comparator: RaceFilterComparator.surface,
        textFilterOptions: [
            { name: 'All', value: 'All' },
            { name: 'Turf', value: 'Turf' },
            { name: 'Dirt', value: 'Dirt' },
            { name: 'Synthetic', value: 'Synthetic' }
        ]
    }
];
